module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-base-conica-bf1644cbd2fe49079996f41347a6e1e1.jpg";